import React, { Component } from "react";
import "./EditVirtualChildren.scss";
import GridDuck from "gridduck";

class StatusPie extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statusCounts: null
        };
    }

    async componentDidMount() {
        const children = await GridDuck.getAssets({
            filters: [
                { field: "virtualParentAsset", value: this.props.item.id },
                { field: "showVirtualMergedChildren", value: true }
            ],
            getAll: true
        });

        const list = children.list || [];

        const statusCounts = {
            monitoring: 0,
            on: 0,
            off: 0,
            disconnected: 0
        };

        for (const child of list) {
            if (child.disconnected || child.gatewayDisconnected) {
                statusCounts.disconnected++;
            } else if (child.userState === "ALWAYS_ON") {
                statusCounts.on++;
            } else if (child.userState === "ALWAYS_OFF") {
                statusCounts.off++;
            } else {
                statusCounts.monitoring++;
            }
        }

        this.setState({ statusCounts, total: list.length });
    }

    renderPieChart() {
        const { statusCounts } = this.state;
        const size = this.props.size || 13;
        const radius = size / 2 - 1;
        const cx = size / 2;
        const cy = size / 2;

        if (!statusCounts) return null;

        const colors = {
            monitoring: "#03a9f4",
            on: "#4caf50",
            off: "#f44336",
            disconnected: "#9e9e9e"
        };

        const total = Object.values(statusCounts).reduce((a, b) => a + b, 0);
        if (total === 0) return null;

        const activeStatuses = Object.entries(statusCounts).filter(([_, count]) => count > 0);

        if (activeStatuses.length === 1) {
            const [[status]] = activeStatuses;
            return (
                <svg width={size} height={size} style={{ pointerEvents: "none", verticalAlign: "middle" }}>
                    <circle cx={cx} cy={cy} r={radius} fill={colors[status]} />
                </svg>
            );
        }

        let cumulative = 0;

        const segments = Object.entries(statusCounts).map(([status, count]) => {
            if (count === 0) return null;

            const value = count / total;
            const startAngle = cumulative * 2 * Math.PI;
            const endAngle = (cumulative + value) * 2 * Math.PI;
            cumulative += value;

            const x1 = cx + radius * Math.sin(startAngle);
            const y1 = cy - radius * Math.cos(startAngle);
            const x2 = cx + radius * Math.sin(endAngle);
            const y2 = cy - radius * Math.cos(endAngle);
            const largeArcFlag = value > 0.5 ? 1 : 0;

            return (
                <path
                    key={status}
                    d={`M${cx},${cy} L${x1},${y1} A${radius},${radius} 0 ${largeArcFlag},1 ${x2},${y2} Z`}
                    fill={colors[status]}
                />
            );
        });

        return (
            <svg width={size} height={size} style={{ pointerEvents: "none", verticalAlign: "middle" }}>
                {segments}
            </svg>
        );
    }

    render() {
        const { statusCounts, total } = this.state;
        if (!statusCounts) return null;

        const connected = total - statusCounts.disconnected;

        return (
            <div className="status-pie" style={{ display: "flex", alignItems: "center", gap: "6px", pointerEvents: "none" }}>
                {this.renderPieChart()}
                <span style={{ fontSize: "12px", color: "#666" }}>{connected}/{total}</span>
            </div>
        );
    }
}

export default StatusPie;
